import React from 'react';

// Components
import Image from '../Image';
import RichTextRenderer from '../richTextRenderer';
// Interfaces
import { CaseStudyCard as CaseStudyCardInterface } from '../../interfaces/card';

function CaseStudyCard({
  card,
  columnSpan,
}: {
  card: CaseStudyCardInterface;
  columnSpan?: number;
}) {
  return (
    <div
      className={`cl-card cl-card--case-study ${card.extraClasses ? card.extraClasses : ''}`}
      key={card.id}
    >
      {card.image && (
        <div className='cl-card__image'>
          <Image data={card.image} />
        </div>
      )}
      <div className='cl-case-study'>
        {card.userType && (
          <div className='cl-case-study__info'>
            <h4>USER TYPE</h4>
            <p>{card.userType}</p>
          </div>
        )}
        {card.integration && (
          <div className='cl-case-study__info'>
            <h4>INTEGRATION</h4>
            <p>{card.integration}</p>
          </div>
        )}
      </div>
      {card.body && (
        <div className='cl-card__body'>
          <RichTextRenderer text={card.body} />
        </div>
      )}
    </div>
  );
}

export default CaseStudyCard;
